import { __awaiter } from '../../_virtual/_tslib.js';
import { options } from '../core/option.js';
import { isInBrowser } from '../utils/isInBrowser.js';
import { indexDbHandler } from './indexdb.js';
import { getGlobalSupport, _global, defalutSpmId } from '../utils/unils.js';
import { USERTRACKTYPE } from '../utils/enum.js';
import { HandlerUserReplace } from '../core/handleReplace.js';
import { isGrayBuvid } from '../utils/isGray.js';
import { importESM } from '@bilibili/dynamic-import';

const _support = getGlobalSupport();
const PLAYER_REPORT_UMD_BASE = 'https://s1.hdslb.com/bfs/static/log-manipulator@0.2.1/index.js';
function getCookie(name) {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? decodeURIComponent(match[2]) : null;
}
// 是否开启用户追踪日志,track
function isStartTarckOrUserLog() {
    try {
        const config = options === null || options === void 0 ? void 0 : options.config['track'];
        const trackGray = options === null || options === void 0 ? void 0 : options.config['track-gray'];
        const buvid3 = getCookie('buvid3');
        const DedeUserID = getCookie('DedeUserID');
        if (DedeUserID && isGrayBuvid(buvid3, trackGray))
            return true;
        if (!config)
            return false;
        if (Object.keys(config).length === 0)
            return false;
        if (Array.isArray(config === null || config === void 0 ? void 0 : config.mid)) {
            return (config === null || config === void 0 ? void 0 : config.mid.includes(DedeUserID)) || (config === null || config === void 0 ? void 0 : config.mid.includes('*'));
        }
        else if (Array.isArray(config === null || config === void 0 ? void 0 : config.buvid)) {
            return (config === null || config === void 0 ? void 0 : config.buvid.includes(buvid3)) || (config === null || config === void 0 ? void 0 : config.buvid.includes('*'));
        }
        return false;
    }
    catch (error) {
        return false;
    }
}
// 是否开启内存中的用户行为日志
function isStartUserLog() {
    var _a;
    return (_a = options === null || options === void 0 ? void 0 : options.config['user-log']) === null || _a === void 0 ? void 0 : _a.length;
}
// 判断是否开启
function isStar() {
    const track = isStartTarckOrUserLog();
    const log = isStartUserLog();
    if (track && log) {
        return 'all';
    }
    else if (track && !log) {
        return 'track';
    }
    else if (!track && log) {
        return 'log';
    }
    else {
        return 'none';
    }
}
// 写入indexdb的方法
// 记录IndexDB 的格式为[time]-[type]:string,info
// 其中 time部分无需手动传入，会自动添加
// demo getLogString('electron-pc-tab', 'pc客户端弹窗切换', { tab: 'home' })===> [2021-08-25 15:00:00:000]-[electron-pc-tab]: pc客户端弹窗切换 {"tab":"home"}
function getLogString(type, info, data) {
    const logData = typeof data === 'string' ? data : JSON.stringify(data ? data : '');
    let message = `[${type}]: ${info} ${logData}`;
    indexDbHandler.add(message);
}
// 页面状态监听
function listenerPageState() {
    // load&refresh
    const buvid = getCookie('buvid3') || '-';
    const mid = getCookie('DedeUserID') || '-';
    let navigationEntries = performance.getEntriesByType('navigation');
    if (navigationEntries.length > 0) {
        if (navigationEntries[0].type === 'reload') {
            getLogString(USERTRACKTYPE.REFRESH, '页面刷新', { url: location.href, mid, buvid });
        }
        else {
            getLogString(USERTRACKTYPE.LOAD, '页面载入', { url: location.href, mid, buvid });
            const windowWidth = window.innerWidth;
            const windowHeight = window.innerHeight;
            getLogString(USERTRACKTYPE.DEVICE, '设备信息', {
                ua: navigator.userAgent,
                window_size: `${windowWidth}*${windowHeight}`,
                url: location.href
            });
        }
    }
    // visibilitychange
    _global.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') {
            getLogString(USERTRACKTYPE.PAGETABSTATUS, '选项卡被激活', { url: location.href });
        }
        else if (document.visibilityState === 'hidden') {
            getLogString(USERTRACKTYPE.PAGETABSTATUS, '选项卡被隐藏', { url: location.href });
        }
    });
    // pageclose
    _global.addEventListener('beforeunload', () => {
        getLogString(USERTRACKTYPE.PAGECLOSE, '页面关闭', { url: location.href });
    });
}
// 获取页面配置归属,mirror 项目区分
function getProjectString() {
    const { spmId, origin, module } = _support.options;
    return `${spmId ? spmId : defalutSpmId}.${origin}.${module}`;
}
// 上传
function uploadLog(blob, is_player_log = false) {
    return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
        const formData = new FormData();
        formData.append('log', blob);
        formData.append('project', getProjectString());
        formData.append('is_player_log', String(is_player_log));
        try {
            const response = yield fetch('https://api.bilibili.com/x/web-frontend/action-log/upload', {
                method: 'POST',
                body: formData,
                credentials: 'include'
            });
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const data = yield response.json();
            resolve(data);
        }
        catch (error) {
            reject('Failed to upload log: ' + error);
        }
    }));
}
// 上传web日志
function uploadWebActionLog() {
    return new Promise((resolve, reject) => {
        indexDbHandler
            .getAll()
            .then(blob => {
            uploadLog(blob)
                .then(res => {
                resolve(res);
            })
                .catch(e => {
                reject(e);
            });
        })
            .catch(e => {
            reject(e);
        });
    });
}
// 上传播放器日志
function uploadPlayerActionLog(isReportPlayer) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            // importESM 播放器提供的上报sdk拉取
            const { reportLogs } = yield importESM((options === null || options === void 0 ? void 0 : options.config['player-log-umd']) || PLAYER_REPORT_UMD_BASE, true);
            return new Promise((resolve, reject) => {
                const key = typeof isReportPlayer === 'boolean' ? 'all' : isReportPlayer;
                reportLogs(key).then(logString => {
                    if (logString) {
                        const blob = new Blob([logString], {
                            type: 'text/plain;charset=utf-8'
                        });
                        resolve(uploadLog(blob, true));
                    }
                    reject('log not found');
                });
            });
        }
        catch (error) {
            console.error('Failed to upload play log: ' + error);
        }
    });
}
function startTracking() {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            if (!isInBrowser())
                return;
            if (!window.indexedDB)
                return;
            // 删除老版本的数据,mirror之前的历史bug（导致用户浏览器崩溃），暂时保留1-2个月
            clearMirrorTracking();
            _support.logType = isStar();
            if (_support.logType === 'none')
                return;
            if (_support.logType !== 'log') {
                // 如果只有log不需要创建indexDb
                yield indexDbHandler.createIndexedDB();
                listenerPageState();
            }
            HandlerUserReplace.historyReplace();
            HandlerUserReplace.hashChangeReplace();
            HandlerUserReplace.domClickReplace();
            HandlerUserReplace.scrollReplace();
            // 错误相关的监听 在step.ts中会默认触发HandlerUserReplace
        }
        catch (error) {
            console.error('Failed to start tracking: ' + error);
        }
    });
}
function startRequestTracking(data) {
    // api相关的利用canBatchReport触发,单独提供方法触发，调用外部canBatchReport后自动收集
    if (isStar() === 'none')
        return;
    HandlerUserReplace.apiReplace(data);
}
// 获取所有数据并且上报
function getReportTrackingLog(isReportPlayer) {
    if (!window.indexedDB)
        return;
    if (isReportPlayer) {
        return uploadPlayerActionLog(isReportPlayer);
    }
    else {
        return uploadWebActionLog();
    }
}
function clearMirrorTracking() {
    indexDbHandler.deleteIndexedDB('MIRROR_TRACK');
}

export { getLogString, getReportTrackingLog, startRequestTracking, startTracking };
